import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { ShellQuery } from '@shared/store/shell/shell-query';
import { ApiService, IApiCall } from '@core/services/api.service';
import { HostPlatformService } from '@shared/services/host-platform.service';

export interface PatientLinkInitResponse {
	Enabled: boolean;
	Reason?: string;
	Message?: string;
	ClinicianId?: string;
}

@Injectable({ providedIn: 'root' })
export class UnifiedPatientsApiService {
	constructor(
		private readonly apiService: ApiService,
		private readonly shellQuery: ShellQuery,
		private readonly hostPlatformService: HostPlatformService
	) {}

	initialize(companyId: number): Observable<PatientLinkInitResponse> {
		return this.shellQuery.rxappBffUrl$.pipe(
			take(1),
			switchMap(bffUrl => {
				if (!bffUrl && this.hostPlatformService.isScanner) {
					throw new Error('Rx App BFF URL is not initialized');
				}

				const doctorId = this.shellQuery.contactId;
				const apiCallOptions: IApiCall = {
					baseUrl: bffUrl ?? undefined,
					selector: 'patientLinkInitialize',
					queryParams: { companyId: String(companyId) },
					showLoader: true,
					options: {
						headers: {
							// eslint-disable-next-line @typescript-eslint/naming-convention
							...(doctorId ? { 'X-Doctor-ID': String(doctorId) } : {})
						}
					}
				};

				return this.apiService.request(apiCallOptions);
			})
		);
	}
}
